import {
  POST_LOGIN_REQUEST,
  POST_LOGIN_SUCCESS,
  POST_LOGIN_FAIL,
  POST_LOGOUT_REQUEST,
  POST_LOGOUT_DONE,
  PUT_CHANGE_PASSWORD_REQUEST,
  PUT_CHANGE_PASSWORD_FAIL,
  PUT_CHANGE_PASSWORD_SUCCESS,
  RESET_LOGIN,
  PRODUCT_LOGIN_REQUEST,
  PRODUCT_LOGIN_SUCCESS,
  PRODUCT_LOGIN_FAIL,
  FETCH_USERS_MODULES_REQUEST,
  FETCH_USERS_MODULES_SUCCESS,
  FETCH_USERS_MODULES_FAIL,
  PUT_CHANGE_DEFAULT_ROLE_REQUEST,
  PUT_CHANGE_DEFAULT_ROLE_SUCCESS,
  PUT_CHANGE_DEFAULT_ROLE_FAIL,
  SET_CURRENT_PRODUCT_LOGIN
} from '../actions/authentication';

const initialState = {
  payload: null,
  isAuthed: false,
  redirectTo: ''
};

export default function authentication(state = initialState, action) {
  switch (action.type) {
    case POST_LOGIN_REQUEST:
      return {
        ...state,
        isAuthed: false,
        error: null,
        payload: action.payload,
        data: null
      };
    case POST_LOGIN_SUCCESS:
    case PRODUCT_LOGIN_SUCCESS:
      return {
        data: action.payload,
        error: null,
        productLogin: {
          isInProgress: false,
          error: null
        },
        userModules: state?.userModules,
        changeRole: state?.changeRole,
        currentProductLogin: state?.currentProductLogin
      };
    case POST_LOGIN_FAIL:
      return {
        ...state,
        ...action.payload
      };
    case SET_CURRENT_PRODUCT_LOGIN:
      return {
        ...state,
        currentProductLogin: action.payload
      };
    case PRODUCT_LOGIN_REQUEST:
      return {
        ...state,
        productLogin: {
          isInProgress: true,
          error: null
        }
      };
    case PRODUCT_LOGIN_FAIL:
      return {
        ...state,
        productLogin: {
          isInProgress: false,
          error: action.payload
        }
      };
    case FETCH_USERS_MODULES_REQUEST:
      return {
        ...state,
        userModules: {
          isInProgress: true,
          error: null,
          data: state?.userModules?.data || null
        }
      };
    case FETCH_USERS_MODULES_SUCCESS:
      return {
        ...state,
        userModules: {
          isInProgress: false,
          error: null,
          data: action.payload
        }
      };
    case FETCH_USERS_MODULES_FAIL:
      return {
        ...state,
        userModules: {
          isInProgress: false,
          error: action.payload,
          data: null
        }
      };
    case POST_LOGOUT_REQUEST:
      return {
        ...state,
        ...action.payload
      };
    case POST_LOGOUT_DONE:
      return {
        ...state,
        isAuthed: false
      };
    case PUT_CHANGE_PASSWORD_SUCCESS:
      return state;
    case PUT_CHANGE_PASSWORD_FAIL:
      return {
        ...state,
        ...action.payload
      };
    case PUT_CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        ...action.payload
      };
    case PUT_CHANGE_DEFAULT_ROLE_REQUEST:
      return {
        ...state,
        changeRole: {
          isInProgress: true,
          error: null
        }
      };
    case PUT_CHANGE_DEFAULT_ROLE_SUCCESS:
      return {
        ...state,
        changeRole: {
          isInProgress: false,
          error: null
        }
      };
    case PUT_CHANGE_DEFAULT_ROLE_FAIL:
      return {
        ...state,
        changeRole: {
          isInProgress: false,
          error: action.payload
        }
      };

    case RESET_LOGIN:
      return { ...initialState };

    default:
      return state;
  }
}
